import FilterIcon from '@mui/icons-material/FilterAltOutlined';
import PropTypes from 'prop-types';
import React, {Component} from 'react';
import {connect} from 'react-redux';
import {byName as filterByName} from '../actions/filter.js';
import {getFilteredName} from '../selectors/index.js';
import QueryInput from './query-input.jsx';

class FilterInput extends Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    value: PropTypes.string.isRequired,
  };

  onChange = query => {
    this.props.dispatch(filterByName(query));
  };

  render() {
    return (
      <QueryInput
        onChange={this.onChange}
        placeholder="Filter basemaps"
        value={this.props.value}
        data-qe="mosaics-filter-input"
        icon={FilterIcon}
      />
    );
  }
}

const mapStateToProps = state => ({
  value: getFilteredName(state),
});

export default connect(mapStateToProps)(FilterInput);
